import { AdpAffClient } from "./affiliate/adpAffiliateClientV2";
import { AdpEcommClient } from "./ecomm/adpEcommClientV2";
import { AffiliateParams } from "./ecomm/types/affiliateParams";
import { ClientConfig } from "./ecomm/types/clientConfig";
import { OfferDimension, PurchaseOrder, PurchaseOrderLineItem } from "./ecomm/types/purchaseOrder";
import { currencyUtil } from "@repo/lib-web";
import { PurchaseOrderTransaction } from "./ecomm/types/purchaseOrderTransaction";
import { CreateAffiliateUrlParams } from "./affiliate/types/createAffiliateUrlParams";
import { CreateUserInfoPageUrlParams } from "./affiliate/types/createUserInfoPageUrlParams";
import { CreateAffiliateUrlResponse } from "./affiliate/types/createAffiliateUrlResponse";
import { CreateAffiliateUrlRequest } from "./affiliate/types/createAffiliateUrlRequest";
import { CreateUserInfoPageUrlRequest } from "./affiliate/types/createUserInfoPageUrlRequest";
const Currency = currencyUtil.Currency



export { };
declare global {
  interface Window {
    _adpClient: AdpEcommClient | undefined;
    _adpAffClient: AdpAffClient | undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }
}

export {
  Currency, PurchaseOrder,
  PurchaseOrderLineItem,
  AffiliateParams,
  ClientConfig,
  PurchaseOrderTransaction,
  AdpEcommClient,
  OfferDimension,

  type CreateAffiliateUrlParams,
  CreateAffiliateUrlRequest,
  CreateAffiliateUrlResponse,
  type CreateUserInfoPageUrlParams,
  CreateUserInfoPageUrlRequest,
  AdpAffClient
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let _clientInstance: AdpEcommClient | undefined = undefined;

export function getEcommClientInstance() {
  return window?._adpClient;
}

export function initEcommClient(conf?: ClientConfig | undefined): AdpEcommClient {

  window._adpClient = window?._adpClient || new AdpEcommClient();
  _clientInstance = window._adpClient;
  if (conf) {
    _clientInstance.initForTransaction(conf);
  } else {
    _clientInstance.initForTracking();
  }

  return _clientInstance;
}

export function initPurchaseOrder(conf?: ClientConfig | undefined): PurchaseOrder {
  if (!_clientInstance) {
    _clientInstance = initEcommClient(conf);
  }
  if (conf && conf.advertiserId && conf.measurementId) {
    _clientInstance.initForTransaction(conf);
  }
  return new PurchaseOrder();
}

export function sendPurchaseOrder(data: PurchaseOrder) {
  _clientInstance?.send(data);
}

initEcommClient();

export function initAffClient() {
  window._adpAffClient = window?._adpAffClient || new AdpAffClient();
  return window._adpAffClient;

}

initAffClient();








